<template>
    <div class="col-md-12">
        <div class="">
            <div class="h2">Create client</div>
        </div>
        <form @submit.prevent="addClient">
            <div class="w-200">
                <div class="container-fluid px-0 bg-light py-3">
                    <div class="form-group p-0">
                        <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                             :class="client.name==='' && isSubmit? 'border-danger':''">
                            <input type="text" autocomplete="none" required
                                   class="form-control  border-0 py-0 shadow-none form-input" placeholder="Client name"
                                   v-model="client.name">
                        </div>
                    </div>
                </div>
            </div>

            <div class="p-4 mb-0 bg-white rounded-lg">
                <div class="h3 mb-3">General information</div>
                <div class="">

                    <div class="container-fluid py-3">
                        <div class="controls">
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="h-100 p-4 mb-0 bg-light rounded-lg">
                                        <div class="h4 mb-3">Address:</div>
                                        <div class="form-group">
                                            <div
                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                :class="client.name==='' && isSubmit? 'border-danger':''">
                                                <input type="text" autocomplete="none" required
                                                       class="form-control border-0 py-0 shadow-none form-input"
                                                       placeholder="Company name"
                                                       v-model="client.name">
                                                <div class="help-block with-errors"></div>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <div
                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                :class="client.billing_street==='' && isSubmit? 'border-danger':''">
                                                <input type="text" autocomplete="none" required
                                                       class="form-control border-0 py-0 shadow-none form-input"
                                                       placeholder="Address"
                                                       v-model="client.billing_street">
                                                <div class="help-block with-errors"></div>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <div class="form-group row">
                                                <div class="col-md-4">
                                                    <div
                                                        class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                        :class="client.billing_zip==='' && isSubmit? 'border-danger':''">
                                                        <input type="text" autocomplete="none" required
                                                               class="form-control border-0 py-0 shadow-none form-input"
                                                               placeholder="Zip code"
                                                               v-model="client.billing_zip">
                                                        <div class="help-block with-errors"></div>
                                                    </div>
                                                </div>
                                                <div class="col-md-8">
                                                    <div
                                                        class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                        :class="client.billing_city==='' && isSubmit? 'border-danger':''">
                                                        <input type="text" autocomplete="none" required
                                                               class="form-control border-0 py-0 shadow-none form-input"
                                                               placeholder="City"
                                                               v-model="client.billing_city">
                                                        <div class="help-block with-errors"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <div
                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                                <select required class="form-control border-0 py-0 shadow-none"
                                                        v-model="client.billing_country_id">
                                                    <option value="1" selected>Denmark</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="h-100 p-4 mb-0 bg-light rounded-lg">
                                        <div class="h4 mb-3">Contact:</div>
                                        <div class="form-group">
                                            <div
                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                :class="client.contact_name==='' && isSubmit? 'border-danger':''">
                                                <input type="text" autocomplete="none" required
                                                       class="form-control border-0 py-0 shadow-none form-input"
                                                       placeholder="Full name"
                                                       v-model="client.contact_name">
                                                <div class="help-block with-errors"></div>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <div
                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                :class="client.contact_phone==='' && isSubmit? 'border-danger':''">
                                                <input type="text" autocomplete="none" required
                                                       class="form-control border-0 py-0 shadow-none form-input"
                                                       placeholder="Phone"
                                                       v-model="client.contact_phone">
                                                <div class="help-block with-errors"></div>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <div
                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                :class="client.contact_email==='' && isSubmit? 'border-danger':''">
                                                <input type="email" autocomplete="none"
                                                       class="form-control border-0 py-0 shadow-none form-input"
                                                       placeholder="Email"
                                                       v-model="client.contact_email">
                                                <div class="help-block with-errors"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="h-100 p-4 mb-0 bg-light rounded-lg">
                                        <div class="h4 mb-3">Other:</div>
                                        <div class="form-group">
                                            <div
                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                :class="client.vat==='' && isSubmit? 'border-danger':''">
                                                <input type="text" autocomplete="none" required
                                                       class="form-control border-0 py-0 shadow-none form-input"
                                                       placeholder="VAT"
                                                       v-model="client.vat">
                                                <div class="help-block with-errors"></div>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <div
                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                :class="client.credit_days==='' && isSubmit? 'border-danger':''">
                                                <input type="number" required
                                                       class="form-control border-0 py-0 shadow-none form-input"
                                                       placeholder="Credit days"
                                                       v-model="client.credit_days">
                                                <div class="help-block with-errors"></div>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <div
                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                :class="client.billing_email==='' && isSubmit? 'border-danger':''">
                                                <input autocomplete="none" type="email"
                                                       class="form-control border-0 py-0 shadow-none form-input"
                                                       placeholder="Invoice email"
                                                       v-model="client.billing_email">
                                                <div class="help-block with-errors"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="clearfix"></div>

                        <div class="row">
                            <div class="col-md-12">
                                <button type="submit" class="btn btn-success mt-3 btn-lg" @click="validation()">Save
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <p class="text-muted"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <a href="/clients" title="Back" class="text-decoration-none d-block mt-3">
            <button class="btn default btn-sm d-flex align-items-center">
                <span class="material-icons-outlined cursor-pointer text-primary">arrow_back</span>
                <span class="pl-1">Back</span>
            </button>
        </a>

    </div>
</template>

<script type="text/ecmascript-6">

export default {
    name: "ClientCreate",
    data() {
        return {
            client: {},
            isSubmit: false
        }
    },
    methods: {
        validation() {
            this.isSubmit = true;
        },
        addClient() {
            let uri = '/clients';
            axios.post(uri, this.client).then((response) => {
                window.location.href = `/clients/${response.data.clientId}/edit`;
            }).catch(err => console.log(err))
        }
    }
}

</script>
